import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
export function AccountAssets(t0) {
  const $ = _c(15);
  const {
    nfts,
    isLoading
  } = t0;
  let t1;
  if ($[0] !== nfts?.nfts) {
    const groupedNFTs = nfts?.nfts?.reduce(_temp, {});
    t1 = Object.values(groupedNFTs || {});
    $[0] = nfts?.nfts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collections = t1;
  let t2;
  if ($[2] !== collections) {
    t2 = () => new Set(collections.map(_temp2));
    $[2] = collections;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [expandedCollections, setExpandedCollections] = useState(t2);
  const [failedImages, setFailedImages] = useState(_temp3);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = imageId => {
      setFailedImages(prev => new Set(prev).add(imageId));
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleImageError = t3;
  if (isLoading) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = _jsx("div", {
        className: "flex flex-col gap-3",
        children: [...Array(2)].map(_temp4)
      });
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  if (!nfts?.nfts?.length) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = _jsx("div", {
        className: "text-b3-react-muted-foreground py-8 text-center",
        children: "No NFTs found"
      });
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = collectionId_0 => {
      setExpandedCollections(prev_0 => {
        const next = new Set(prev_0);
        if (next.has(collectionId_0)) {
          next.delete(collectionId_0);
        } else {
          next.add(collectionId_0);
        }
        return next;
      });
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const toggleCollection = t4;
  let t5;
  if ($[8] !== collections || $[9] !== expandedCollections || $[10] !== failedImages) {
    let t6;
    if ($[12] !== expandedCollections || $[13] !== failedImages) {
      t6 = collection => {
        const isExpanded = expandedCollections.has(collection.collection_id);
        return _jsxs("div", {
          className: "flex flex-col gap-3",
          children: [_jsxs("button", {
            onClick: () => toggleCollection(collection.collection_id),
            className: "flex w-full items-center justify-between",
            children: [_jsxs("div", {
              className: "flex items-center gap-1",
              children: [collection.collection_image && !failedImages.has(`collection-${collection.collection_id}`) && _jsx("img", {
                src: collection.collection_image,
                alt: collection.collection_name,
                className: "h-5 w-5 shrink-0 rounded object-cover",
                onError: () => handleImageError(`collection-${collection.collection_id}`)
              }), _jsxs("p", {
                className: "font-neue-montreal-medium text-[14px] text-[#3f3f46]",
                children: [collection.collection_name, " (", collection.nfts.length, ")"]
              })]
            }), _jsx("svg", {
              className: `h-[18px] w-[18px] shrink-0 transition-transform ${isExpanded ? "rotate-180" : ""}`,
              viewBox: "0 0 18 18",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: _jsx("path", {
                d: "M4.5 6.75L9 11.25L13.5 6.75",
                stroke: "#51525C",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              })
            })]
          }), isExpanded && _jsx("div", {
            className: "flex gap-3 overflow-x-auto",
            children: collection.nfts.map(nft_0 => _jsx("div", {
              className: "bg-b3-react-muted relative h-[98px] w-[98px] shrink-0 overflow-hidden rounded-lg",
              children: !failedImages.has(nft_0.nft_id) && _jsx("img", {
                src: nft_0.previews?.image_medium_url || nft_0.extra_metadata?.image_original_url || nft_0.collection?.image_url || "",
                alt: nft_0.name || "NFT",
                className: "h-full w-full object-cover",
                onError: () => handleImageError(nft_0.nft_id)
              })
            }, nft_0.nft_id))
          })]
        }, collection.collection_id);
      };
      $[12] = expandedCollections;
      $[13] = failedImages;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = _jsx("div", {
      className: "flex flex-col gap-3",
      children: collections.map(t6)
    });
    $[8] = collections;
    $[9] = expandedCollections;
    $[10] = failedImages;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp4(_, i) {
  return _jsxs("div", {
    className: "animate-pulse",
    children: [_jsx("div", {
      className: "bg-b3-react-muted mb-3 h-6 w-48 rounded"
    }), _jsxs("div", {
      className: "flex gap-3",
      children: [_jsx("div", {
        className: "bg-b3-react-muted h-[98px] w-[98px] shrink-0 rounded-lg"
      }), _jsx("div", {
        className: "bg-b3-react-muted h-[98px] w-[98px] shrink-0 rounded-lg"
      })]
    })]
  }, i);
}
function _temp3() {
  return new Set();
}
function _temp2(c) {
  return c.collection_id;
}
function _temp(acc, nft) {
  const collectionId = nft.collection?.collection_id || "unknown";
  if (!acc[collectionId]) {
    acc[collectionId] = {
      collection_id: collectionId,
      collection_name: nft.collection?.name || "Unknown Collection",
      collection_image: nft.collection?.image_url || nft.previews?.image_small_url || "",
      nfts: []
    };
  }
  acc[collectionId].nfts.push(nft);
  return acc;
}